module.exports = __webpack_public_path__ + "img/external-product-numbers.677e909e.svg";